import React, { ReactElement, Suspense } from 'react'
import indexRoutes from 'routes/index.routes'
import { LoadingPlaceholderContainer } from 'ui/atoms'
import PrivateRoutes from 'ui/components/PrivateRoutes/PrivateRoutes'

function UnauthenticatedApp(): ReactElement {
  return (
    <Suspense fallback={<LoadingPlaceholderContainer />}>
      <PrivateRoutes routes={indexRoutes} />
    </Suspense>
  )
}

export default UnauthenticatedApp
